<template>
    <footer v-if="$route.query.isApp != 1">
        <div class="footer-tcs">
            <div class="lg-container ">
                <div class="row">
                    <h3 style="font-size: 0;display: none">{{$t('content.h3.home.footer')}}</h3>
                    <div class="footer-item col-sm-4">
                        <h4><span>{{$t('footer.customer_service')}}</span></h4>
                        <a href="/faq" :data-item-id="footer.faq.id" data-item-type="link"><span>{{$t('footer.faqs')}}</span></a>
                        <div class="clear"></div>
                        <a href="/nutritional-content" :data-item-id="footer.nutritional.id" data-item-type="link"><span>{{$t('footer.nutritional')}}</span></a>
                        <div class="clear"></div>
                        <a href="/indication-based" :data-item-id="footer.indication.id" data-item-type="link"><span>{{$t('footer.cft_cct')}}</span></a>
                        <div class="clear"></div>
                        <a href="/privacy" :data-item-id="footer.privacy.id" data-item-type="link"><span>{{$t('footer.cft_sec')}}</span></a>
                        <div class="clear"></div>
                        <a href="/terms" :data-item-id="footer.terms.id" data-item-type="link"><span>{{$t('footer.cft_umr')}}</span></a>
                        <div class="clear"></div>
                        <a href="https://corp.pizzahut.jp/" target="_blank" :data-item-id="footer.corp.id" data-item-type="link"><span>{{$t('footer.title_logo')}}</span></a>
                        <div class="clear"></div>
                        <a href="https://corp.pizzahut.jp/sustainability" target="_blank" :data-item-id="footer.corp.id" data-item-type="link"><span>{{$t('footer.title_logo_2')}}</span></a>
                        <div class="clear"></div>
                        <a href="https://corp.pizzahut.jp/safety" target="_blank" :data-item-id="footer.corp.id" data-item-type="link"><span>{{$t('footer.title_logo_3')}}</span></a>
                        <div class="clear"></div>
                        <a href="https://corp.pizzahut.jp/kodawari" target="_blank" :data-item-id="footer.corp.id" data-item-type="link"><span>{{$t('footer.commitment')}}</span></a>
                        <div class="clear"></div>
                    </div>
                    <div class="footer-item col-sm-4">
                        <div class="item">
                            <h4><span>{{$t('footer.look_for_deal')}}</span></h4>
                            <a href="/topic" :data-item-id="footer.topic.id" data-item-type="link"><span>{{$t('footer.topics')}}</span></a>
                            <div class="clear"></div>
                            <a href="/hutrewards" :data-item-id="footer.membership.id" data-item-type="link"><span>{{$t('footer.membership')}}</span></a>
                            <div class="clear"></div>
                            <a href="https://media.pizzahut.jp" :data-item-id="footer.media.id" data-item-type="link" target="_blank"><span>{{$t('footer.media')}}</span></a>
                            <a href="https://www.pizzahut.jp/topic/menu/pizza" data-item-type="link" target="_blank"><span>{{$t('footer.original_pizza_price')}}</span></a>

                        </div>
                        <div class="clear"></div>
                        <h4><span>{{$t('footer.related_information')}}</span></h4>
                        <a href="https://corp.pizzahut.jp/recruit" data-item-type="link">{{$t('footer.full_time_job')}}</a>
                        <a href="https://job-pizzahut.net/jobfind-pc/" :data-item-id="footer.carrier.id" data-item-type="link">{{$t('footer.carrier')}}</a>
                        <a :href="$const.FRANCHISING_LINK" target="__blank">{{$t('footer.franchising')}}</a>

                    </div>
                    <div class="footer-item col-sm-4">
                        <div class="item">
                        <h4><span>{{$t('footer.sns')}}</span></h4>
                        <div class="ph3_grid-col social">
                            <ul class="ph3_footer-sns-list">
                                <li><a href="https://www.facebook.com/pizzahut.japan" :data-item-id="footer.facebook.id" data-item-type="link" class="ph3_footer-icon ph3_has-facebook" target="_blank"><span style=""><img src="../../assets/images/icons/facebook-icon-square.png"  width="28" class="pr-5"/>
                          </span><span class="pl-5">Facebook</span></a></li>
                                <li><a href="https://twitter.com/Pizza_Hut_Japan" :data-item-id="footer.twitter.id" data-item-type="link" class="ph3_footer-icon ph3_has-twitter" target="_blank"><span style="height: 24px"><img src="../../assets/images/icons/logo-white.png" width="28" class="pr-5"/></span><span class="pl-5">X</span></a></li>
                                <li><a href="https://www.youtube.com/user/PizzaHutWeb" :data-item-id="footer.youtube.id" data-item-type="link" class="ph3_footer-icon ph3_has-youtube" target="_blank"><span style="background: #fff"><i class="fa fa-youtube-play" style="font-size:24px;background: #e52d27;padding: 0 3px;"></i></span><span class="pl-5">YouTube</span></a></li>
                                <li><a href="https://lin.ee/gvZkFek" :data-item-id="footer.line.id" data-item-type="link" class="ph3_footer-icon ph3_has-line" target="_blank"><span style="height: 24px"><i class="fa-line-app"></i></span><span class="pl-5">LINE</span></a></li>
                                <li><a href="https://www.instagram.com/pizza_hut_japan/?hl=ja" :data-item-id="footer.instagram.id" data-item-type="link" class="ph3_footer-icon ph3_has-instagram" target="_blank"><span style="height: 24px"><i class="fa-instagram-web"></i></span><span class="pl-5">Instagram</span></a></li>
                                <li><a href="https://www.tiktok.com/@pizza_hut_japan" :data-item-id="footer.tiktok.id" data-item-type="link" class="ph3_footer-icon ph3_has-tiktok" target="_blank"><span style="height: 24px"><img src="../../assets/images/icons/tiktok-logo.svg"  width="28" class="pr-5"/></span><span class="pl-5">TikTok</span></a></li>
                            </ul>
                        </div>
                        </div>
                        <div class="item">
                            <h4><span>{{$t('footer.order_app')}}</span></h4>
                            <div class="clearfix"></div>
                            <div class="ph3_grid-col ">
                                <ul class="ph3_footer-app-list">
                                    <li class="ph3_googleplay"><a href="https://play.google.com/store/apps/details?id=jp.pizzahut.aorder&amp;hl=ja" target="_blank" :data-item-id="footer.google.id" data-item-type="link" >
                            <img src="./../../assets/images/icons/google-play-badge.png" alt="ANDROID APP ON Google play" style="width: 135px; height:53px; margin-top: -6px"></a></li>
                                    <li class="ph3_appstore"><a href="https://itunes.apple.com/jp/app/pizahatto-gong-shiapuri-zhai/id612621774?mt=8" target="_blank" :data-item-id="footer.apple.id" data-item-type="link">
                            <img src="./../../assets/images/icons/ph3_bnr-appstore.png" alt="Download on the App Store"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="xs-flex-center footer-text">
            Copyright © PIZZA HUT JAPAN LTD. All Rights Reserved.
        </div>
    </footer>

</template>

<script>
  import NavCategory from '../partials/NavCategory.vue'
export default {
  components: {
    NavCategory
  },
  mounted () {
    this.eventTrackingMoudle(this.footer)
  },
  data () {
    return {
      menus: [
      ],
      footer: {
        topic: {
          id: 'footer-topic',
          name: 'topics',
          type: 'internal',
          attributes: {
            destination: this.$router.resolve({name: 'campaigns'}).route.fullPath
          }
        },
        carrier: {
          id: 'footer-carrier',
          name: 'carriers',
          type: 'external',
          attributes: {
            destination: 'https://job-pizzahut.net/jobfind-pc/'
          }
        },
        corp: {
          id: 'footer-corp',
          name: 'corp',
          type: 'external',
          attributes: {
            destination: 'https://corp.pizzahut.jp/'
          }
        },
        facebook: {
          id: 'footer-facebook',
          name: 'facebook',
          type: 'external',
          attributes: {
            destination: 'https://www.facebook.com/pizzahut.japan'
          }
        },
        google: {
          id: 'footer-google-store',
          name: 'google-store',
          type: 'external',
          attributes: {
            destination: 'https://play.google.com/store/apps/details?id=jp.pizzahut.aorder&amp;hl=ja'
          }
        },
        apple: {
          id: 'footer-apple',
          name: 'apple',
          type: 'external',
          attributes: {
            destination: 'https://itunes.apple.com/jp/app/pizahatto-gong-shiapuri-zhai/id612621774?mt=8'
          }
        },
        youtube: {
          id: 'footer-youtube',
          name: 'youtube',
          type: 'external',
          attributes: {
            destination: 'https://www.youtube.com/user/PizzaHutWeb'
          }
        },
        twitter: {
          id: 'footer-twitter',
          name: 'twitter',
          type: 'external',
          attributes: {
            destination: 'https://twitter.com/Pizza_Hut_Japan'
          }
        },
        line: {
          id: 'footer-line',
          name: 'line',
          type: 'external',
          attributes: {
            destination: 'https://lin.ee/gvZkFek'
          }
        },
        instagram: {
          id: 'footer-instagram-web',
          name: 'instagram',
          type: 'external',
          attributes: {
            destination: 'https://www.instagram.com/pizza_hut_japan/?hl=ja'
          }
        },
        tiktok: {
          id: 'footer-tiktok-web',
          name: 'tiktok',
          type: 'external',
          attributes: {
            destination: 'https://www.tiktok.com/@pizza_hut_japan'
          }
        },
        faq: {
          id: 'footer-faq',
          name: 'faq',
          type: 'internal',
          attributes: {
            destination: this.$router.resolve({name: 'faq'}).route.fullPath
          }
        },
        nutritional: {
          id: 'footer-nutritional',
          name: 'nutritional',
          type: 'internal',
          attributes: {
            destination: this.$router.resolve({name: 'nutritional'}).route.fullPath
          }
        },
        indication: {
          id: 'footer-indication',
          name: 'commercial-transactions',
          type: 'internal',
          attributes: {
            destination: this.$router.resolve({name: 'indication'}).route.fullPath
          }
        },
        media: {
          id: 'footer-media',
          name: 'media',
          type: 'external',
          attributes: {
            destination: 'https://media.pizzahut.jp'
          }
        },
        membership: {
          id: 'footer-membership',
          name: 'hutrewards',
          type: 'internal',
          attributes: {
            destination: this.$router.resolve({name: 'hutrewards'}).route.fullPath
          }
        },
        terms: {
          id: 'footer-terms',
          name: 'terms',
          type: 'internal',
          attributes: {
            destination: this.$router.resolve({name: 'terms'}).route.fullPath
          }
        },
        privacy: {
          id: 'footer-privacy',
          name: 'privacy',
          type: 'internal',
          attributes: {
            destination: this.$router.resolve({name: 'privacy'}).route.fullPath
          }
        }
      }
    }
  },
  methods: {
  }
}
</script>
<style scoped>
  ul,ol{
    list-style-type: none;
  }
  /* .ph3_footer-icon
----------------------------------------------- */
  .ph3_footer-icon {
    position: relative;
    display: inline-block;
  }
  .ph3_footer-icon:before {
    position: absolute;
    top: 50%;
    left: 10px;
  }

  /* .ph3_has-facebook
  ----------------------------------------------- */
  .ph3_footer-icon.ph3_has-facebook:before {
    background-position: -52px -115px;
    width: 24px;
    height: 24px;
    margin-top: -12px;
  }

  /* .ph3_has-twitter
  ----------------------------------------------- */
  .ph3_footer-icon.ph3_has-twitter:before {
    background-position: -164px -25px;
    width: 24px;
    height: 20px;
    margin-top: -10px;
  }

  .fa-line-app {
    background-image: url(https://static.pizzahut.jp/jp/logos/LINE_APP.png) !important;
    width: 24px;
    height: 24px;
    display: inline-block;
    background-position: center;
    background-size: cover;
  }

  /* .ph3_has-youtube
  ----------------------------------------------- */
  .ph3_footer-icon.ph3_has-youtube:before {
    background-position: 0px -115px;
    width: 24px;
    height: 24px;
    margin-top: -12px;
  }

  .fa-instagram-web {
    background-image: url(https://static.pizzahut.jp/jp/logos/Instagram.png) !important;
    width: 24px;
    height: 24px;
    display: inline-block;
    background-position: center;
    background-size: cover;
  }
.fa-tiktok-web {
    width: 24px;
    height: 24px;
    display: inline-block;
    background-position: center;
    background-size: cover;
  }
  /* .ph3_has-familyapps
  ----------------------------------------------- */
  .ph3_footer-icon.ph3_has-familyapps:before {
    background-position: -26px -115px;
    width: 24px;
    height: 24px;
    margin-top: -12px;
  }
  /* .ph3_footer-sns-list
----------------------------------------------- */
  .ph3_footer-sns-list {
    margin-left: -2.73%;
    font-size: 11px;
    line-height: 1.2;
    margin-bottom: 7px;
  }
  .ph3_footer-sns-list > li {
    float: left;
    width: 47.33%;
    margin-left: 2.66%;
  }
  .ph3_footer-sns-list > li:nth-child(2n+1) {
    clear: both;
  }
  .ph3_footer-sns-list li {
    margin-bottom: 8px;
  }
  .ph3_footer-sns-list a {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.6);
    padding: 9px 11px 8px 10px;
    display: block;
  }
  .ph3_footer-sns-list .ph3_familyapps a {
    padding-top: 7px;
    padding-right: 0;
    padding-bottom: 7px;
  }
  @media only screen and (max-width: 640px) {
    .ph3_footer-sns-list {
      margin-bottom: 0;
    }
  }

  /* .ph3_footer-app-list
----------------------------------------------- */
  .ph3_footer-app-list {
    background: #0b0b0a;
    font-size: 11px;
    margin: 0;
    padding: 11px 10px 65px 0;
  }
  .ph3_footer-app-list li {
    float: left;
  }
  .ph3_footer-app-list li span {
    margin: 0 0 5px;
    display: block;
  }
  .ph3_footer-app-list .ph3_googleplay {
    width: 41.36691%;
    margin-left: 5.03597%;
  }
  .ph3_footer-app-list .ph3_appstore {
    width: 48.56115%;
    margin-left: 5.03597%;
  }
  @media only screen and (max-width: 950px) {
    .ph3_footer-app-list .ph3_googleplay {
      width: auto;
    }
    .ph3_footer-app-list .ph3_appstore {
      width: auto;
    }
  }
  @media only screen and (max-width: 660px) {
    .ph3_footer-app-list .ph3_googleplay {
      width: 41.36691%;
    }
    .ph3_footer-app-list .ph3_appstore {
      width: 48.56115%;
    }
  }

  /* .ph3_footer-copyright
  ----------------------------------------------- */
  .ph3_footer-copyright {
    border-top: 1px solid #827c7b;
    color: #8d8d8c;
    font-size: 1rem;
    text-align: center;
    margin: 0;
    padding: 11px 0 20px;
  }
  @media only screen and (max-width: 640px) {
    .ph3_footer-copyright {
      border-top: 4px solid #484846;
      color: #aeaeae;
      font-size: .6rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeFooterJP.vue